export default {
  computed: {
    hostname() {
      return window.location.hostname
    }
  },
  methods: {
    findGetParameter (parameterName) {
      let result = null, tmp = []
      location.search
        .substr(1)
        .split('&')
        .forEach(function (item) {
          tmp = item.split('=')
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
      return result
    },
    getParameters () {
      let tmp = []
      let params = {}

      location.search
        .substr(1)
        .split('&')
        .forEach((item) => {
          tmp = item.split('=')
          params[tmp[0]] = decodeURIComponent(tmp[1])
          if (this.isNumeric(params[tmp[0]])) {
            params[tmp[0]] = Number(params[tmp[0]])
          }
        })
      return params
    },
    redirect (url) {
      window.location.href = url
    },
    newTab (url) {
      window.open(url)
    },
    isNumeric (str) {
      if (typeof str != 'string') return false // we only process strings!
      return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    },
    goBack() {
      window.history.back()
    }
  }
}
